import React from 'react'
import IndividaulForm from '../../../../components/user/join-form/Individaul'

const GeneralUserSocial = () => {
   return (
      <IndividaulForm isSocial={true} />
   )
}

export default GeneralUserSocial